import React, { createContext } from 'react';
import { GoalsOptionsDTO } from '../../api/useGoalsOptionsQuery';
import { StepName } from '../SetGoal.meta';

export enum FinancialGoalType {
  LargePurchase,
  Expense,
}

export enum SavePeriod {
  Monthly,
  Yearly,
}

export interface WizardState {
  isFinancialGoal: boolean;
  goalDescription: string;
  goalType: FinancialGoalType;
  purchase: {
    amount: number;
    inflation: number;
    isRecurringPurchase: boolean;
    oneTimeOptions?: {
      isAtRetirement: boolean;
      targetYear: number;
    };
    recurringOptions?: {
      isAtRetirement: boolean;
      startYear: number;
      repeatEvery: number;
      repeatFor: number;
    };
  };
  expense: {
    amount: number;
    startDate: number;
    saveEvery: SavePeriod;
    saveForLength: number;
    saveForPeriod: SavePeriod;
  };
  accountIds: string[];
  targetDate: string;
}

interface Context {
  wizard: Partial<WizardState>;
  setWizard: React.Dispatch<React.SetStateAction<Partial<WizardState>>>;
  setStep: React.Dispatch<React.SetStateAction<StepName>>;
  onSuccess(wizard: Partial<WizardState>): void;
  options: GoalsOptionsDTO;
  setIsReviewingStep: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SetGoalContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: React.ReactNode;
}

export const SetGoalProvider = ({ children, value }: Props) => (
  <SetGoalContext.Provider value={value}>{children}</SetGoalContext.Provider>
);
